import { Component } from 'preact'
// eslint-disable-next-line import/no-internal-modules
import { DataSourceOpts, StateAwareHeaderComponentProps } from '@insided/deprecated-control/overview'
// eslint-disable-next-line import/no-internal-modules
import { UserData } from '@insided/deprecated-control/UserOverview/DataSource'
// eslint-disable-next-line import/no-internal-modules
import ExportCsvComponent from '@insided/deprecated-control/UserOverview/HeaderActions/ExportCsvComponent'
// eslint-disable-next-line import/no-internal-modules
import ButtonControl from '@insided/deprecated-preact-components/button-control'
// eslint-disable-next-line import/no-internal-modules
import { CustomProfileFieldList } from '@insided/deprecated-control/UserOverview/Columns'
import DeleteSegmentModal from './DeleteSegmentModal'
import { deleteSegment, updateSegment } from './api'

interface HeaderActionsComponentProps extends StateAwareHeaderComponentProps<UserData> {
  id: number
  title: string
  description: string
  customProfileFields: CustomProfileFieldList
  isTitleChanged: boolean
  isDescriptionChanged: boolean
  onTitleUpdated: (newValue: string) => void
  onCancel: () => void
}

interface State {
  showDeleteModal: boolean
  showDeleteError: boolean
}

class HeaderActionsComponent extends Component<HeaderActionsComponentProps, State> {
  constructor(props: HeaderActionsComponentProps) {
    super(props)

    this.state = {
      showDeleteModal: false,
      showDeleteError: false
    }
  }

  showDeleteModal = () => this.setState({ showDeleteModal: true })

  hideDeleteModal = () => this.setState({ showDeleteModal: false })

  onDelete = async () => {
    const { id } = this.props
    await deleteSegment(id)
      .then(() => window.location.assign('/users/segments'))
      .catch(() => {
        this.setState({ showDeleteError: true })
      })
  }

  onCancel = () => {
    const { onCancel } = this.props

    onCancel()
  }

  onUpdate = async () => {
    const { id, title, description, filters = {}, customProfileFields } = this.props

    await updateSegment(id, title, description, filters, customProfileFields)
      .then(() => window.location.assign(`/users/segments/${id}`))
      .catch(() => {
        this.setState({ showDeleteError: true })
      })
  }

  exportOptions = (): DataSourceOpts => {
    const { filters = {}, pagination = { page: 1, pageSize: 10 }, sort = {} } = this.props

    return { pagination, filters, sort }
  }

  render() {
    const { areFiltersApplied, title, isTitleChanged, isDescriptionChanged } = this.props
    const { showDeleteModal, showDeleteError } = this.state
    const canUpdate = areFiltersApplied || isTitleChanged || isDescriptionChanged

    const { customProfileFields } = this.props

    return (
      <div>
        <ButtonControl
          onClick={this.showDeleteModal}
          title='Delete'
          variant='warning'
          newStyle
          size='medium'
        />
        {canUpdate && ([
          <ButtonControl
            onClick={this.onCancel}
            key='reset'
            title='Cancel'
            variant='secondary'
            newStyle
            size='medium'
          />,
          <ButtonControl
            onClick={this.onUpdate}
            key='update'
            title='Save changes'
            variant='success'
            newStyle
            size='medium'
          />
        ])}
        <ExportCsvComponent
          options={this.exportOptions()}
          customProfileFields={customProfileFields}
        />
        <DeleteSegmentModal
          onClose={this.hideDeleteModal}
          onDelete={this.onDelete}
          showModal={showDeleteModal}
          showGenericError={showDeleteError}
          title={title}
        />
      </div>
    )
  }
}

export default HeaderActionsComponent
